import React, { useEffect } from "react";
import loadReviewsWidget from "services/load-reviews-widget";
import Image from "components/image";
import { formatTitle } from "helpers/format-title";

const ImageReviews = ({ data }) => {
	useEffect(() => {
		loadReviewsWidget(data._key);
	}, []);

	return (
		<div className="flex flex-col md:flex-row m-auto justify-center my-10 lg:my-20 w-11/12 gap-5">
			<div className="w-full md:w-3/5 text-center">
				<h2>{formatTitle(data.title)}</h2>
				<div id={data._key}></div>
			</div>

			<div className="w-1/2 hidden md:block">
				<Image image={data.image?.asset} alt={data.image?.alt} />
			</div>
		</div>
	);
};

export default ImageReviews;
